export default "__VITE_ASSET__2a4c9f4c__"